export const actionButtons = {
  UPCOMING: 1,
  PAST: 2,
  ORGANISED_MATCHES: 3,
};
